import api from "./api";

const login = (authentication) =>
  api.post("auth/signin", { ...authentication, checkNumCad: false });

export default { login };
